export default __webpack_public_path__ + "static/media/aboutbg.a718a75c.png";